import type { ContractTemplateLock } from 'global-intern-types';
import formatiereSperrzeit from './sperrzeit';

// RITA-1541: Texte der Bearbeitungssperre, wie von Julia am 18.10.2026 freigegeben (Entwurf v2).
// Niemand kann eine laufende Bearbeitung übernehmen; nur dieselbe Person darf im zweiten Fenster
// weiterarbeiten. Alle Texte duzen wie der übrige Vertragseditor.

export const SPERRE_FREI_TEXT = 'Die Vorlage ist jetzt frei. Zum Bearbeiten den aktuellen Stand laden.';
export const SPERRE_FREI_KNOPF = 'Aktuellen Stand laden und bearbeiten';
export const ZWEITES_FENSTER_TITEL = 'Vorlage ist schon geöffnet';
export const ZWEITES_FENSTER_NUR_LESEN = 'Nur lesen';
export const ZWEITES_FENSTER_WEITER = 'Hier weiterbearbeiten';
export const KONFLIKT_TITEL = 'Die Vorlage wurde inzwischen geändert';
export const KONFLIKT_NEU_LADEN = 'Neu laden – meine Änderungen verwerfen';
export const KONFLIKT_TROTZDEM = 'Trotzdem speichern';
export const NUR_LESEN_STATUS = 'Nur lesen';
export const ZURUECK_ZUR_UEBERSICHT = 'Zurück zur Übersicht';

const seit = (sperre: ContractTemplateLock, jetzt?: Date) => formatiereSperrzeit(sperre.started_at, jetzt);

/** Bild 1: andere Person bearbeitet; man kann nur lesen. */
export const fremdeSperreText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  `Wird gerade von ${sperre.display_name} bearbeitet (seit ${seit(sperre, jetzt)}). Du kannst nur lesen, bis diese Person gespeichert hat oder 30 Minuten lang nichts eingegeben wurde.`;

/** Bild 3: eigene Sperre war abgelaufen, jemand anderes bearbeitet inzwischen. */
export const verloreneSperreText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  `${sperre.display_name} bearbeitet diese Vorlage jetzt (seit ${seit(sperre, jetzt)}). Deine Bearbeitung war nach 30 Minuten ohne Eingabe abgelaufen. Du kannst nur lesen; deine nicht gespeicherten Änderungen können hier nicht mehr gespeichert werden.`;

/** Bild 5: dieselbe Person bearbeitet in einem anderen Fenster; hier nur lesen. */
export const anderesFensterText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  `Du bearbeitest diese Vorlage in einem anderen Fenster (seit ${seit(sperre, jetzt)}). Hier kannst du nur lesen.`;

/** Bild 5, altes Fenster: die Bearbeitung wurde in einem anderen Fenster fortgesetzt. */
export const anderesFensterVerlorenText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  `Du hast die Bearbeitung um ${seit(sperre, jetzt)} in einem anderen Fenster fortgesetzt. Hier kannst du nur lesen.`;

/** Bild 5, Fenster „Vorlage ist schon geöffnet“. */
export const zweitesFensterFrageText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  `Du bearbeitest diese Vorlage bereits in einem anderen Fenster (seit ${seit(sperre, jetzt)}). Hier weiterbearbeiten?`;

/** Bild 4: Warnung beim Speichern; laut Ticket nur die Uhrzeit, keine Person. */
export const konfliktText = (gespeichertUm: string, jetzt?: Date): string =>
  `Diese Vorlage wurde um ${formatiereSperrzeit(gespeichertUm, jetzt)} gespeichert, nachdem du sie geöffnet hast. Wenn du jetzt speicherst, überschreibst du diese Änderungen.`;

/** Bild 6: Zeile der Liste. */
export const listenSperreText = (sperre: ContractTemplateLock, jetzt?: Date): string =>
  sperre.is_mine
    ? `Du bearbeitest (seit ${seit(sperre, jetzt)})`
    : `${sperre.display_name} bearbeitet (seit ${seit(sperre, jetzt)})`;

/** Bild 6: Hinweis am ausgegrauten Papierkorb. */
export const papierkorbGesperrtText = (sperre: ContractTemplateLock): string =>
  `Wird gerade von ${sperre.display_name} bearbeitet`;

/** Editor: Server hat das Speichern wegen fremder Sperre abgelehnt (LOCKED). */
export const speichernGesperrtText = (displayName: string): string =>
  `Diese Vorlage wird gerade von ${displayName} bearbeitet und kann nicht gespeichert werden.`;

/** Liste: Server hat das Löschen wegen fremder Sperre abgelehnt (LOCKED). */
export const loeschenGesperrtText = (displayName: string): string =>
  `Die Vertragsvorlage wird gerade von ${displayName} bearbeitet und kann nicht gelöscht werden.`;
